import React from "react";
import styles from "./styles/ShortDivider.module.css";

function ShortDivider() {
    return (
        <div className={styles.shortDividerContainer}>
            <div className={styles.shortDivider}></div>
        </div>
    );
}

export default ShortDivider;
